/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number2SansDark = () => (
	<>
		<path
			fill={'#0D2A5E'}
			d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
		/>
		<path
			fill="white"
			d="M9.89999 24.47V21.67C16.73 16.64 18.74 14.91 18.74 12.86C18.74 11.41 17.41 10.68 16.01 10.68C14.13 10.68 12.68 11.43 11.55 12.61L9.51999 10.26C11.15 8.38 13.63 7.53 15.95 7.53C19.51 7.53 22.33 9.53 22.33 12.86C22.33 15.71 19.98 18.19 15.5 21.35H22.46V24.48H9.88999L9.89999 24.47Z"
		/>
	</>
);

export default Number2SansDark;
